import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { FuelTypesService } from 'src/app/services/fuel-types/fuel-types.service';

@Component({
  selector: 'app-edit-fuel-type',
  templateUrl: './edit-fuel-type.component.html',
  styleUrls: ['./edit-fuel-type.component.css']
})
export class EditFuelTypeComponent implements OnInit{
  form!: FormGroup;
  public errorMessage: string | null = null;
  isProcessing: boolean = false;
  submitted: boolean = false;
  public Id: string | null = null;
  public fuelTypeData:any;

  constructor(
    private fuelTypesService:FuelTypesService,
    private formBuilder: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private activatedRoute: ActivatedRoute,
  ){
    this.form = this.formBuilder.group({
      fuel_type: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.Id = param['get']('id')
    })

    if(this.Id){
      this.fetchFuelTypeData(this.Id);
    }else{
      //Navigate back to users list with error
      this.globalService.setGlobalErrorMessage("Unable to select fuel type for editing!");
      this.router.navigate(['settings/fuel-types-list']);
    }
  }

   /**
   * Get fuel type data
   * @param Id
   */
   fetchFuelTypeData(Id: string): void {
    this.fuelTypesService.edit(Id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.fuelTypeData = response;
          if(this.fuelTypeData.status==='no_data' || this.fuelTypeData.status.length===0){
            this.errorMessage=this.fuelTypeData.message;
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;

    if (this.form.valid) {
      const formData = {
        ...this.form.value,
      };

      this.fuelTypesService.update(formData,this.Id).subscribe(response => {
        if(response.status==='success'){

          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);

          // Redirect back to the list
          this.router.navigate(['settings/fuel-types-list']);
        }else if(response.status==='error'){
          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.submitted=false;
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
    }
  }
}
